import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IInboxJob } from '../interfaces/inbox-job';
import { IInboxJobFilter } from '../interfaces/inbox-job-filter';
import { EditService } from './edit.service';

@Injectable({ providedIn: 'root' })
export class CustomerInboxJobsService extends EditService<IInboxJob, IInboxJobFilter> {
  baseUrl = '/api/inboxjobs';
  url = '/api/inboxjobs/getCustomerJobs';
  entityTitle = 'CustomerInboxJobs';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public cancelOrder(orderId: number): Promise<any> {
    return this.handleRequest(
      this.http.get<any>(`${this.baseUrl}/cancelOrder?id=${orderId}`),
      this.handlersFactory.getForReadAll(),
    );
  }

  getPage(filter: IInboxJobFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.handleRequest(
      this.http.get(this.url, { params: params }),
      this.handlersFactory.getForReadByFilter(),
    ).then(this.extractData);
  }
}
